/* eslint-disable max-len */
import { motion } from 'framer-motion';
import './legalMentionsStyles.scss';

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const itemVariant = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
};

function LegalMentions() {
  return (
    <motion.div
      className="legal-mentions-container"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="legal-content">
        <motion.div className="header-container" variants={itemVariant}>
          <h1>Mentions légales</h1>
          <div className="divider">
            <div className="divider-line" />
          </div>
          <p className="date-update"><strong>Date de dernière mise à jour : 02 mars 2025</strong></p>
        </motion.div>

        <motion.div className="section" variants={itemVariant}>
          <h2>1. Identification de l'entreprise</h2>
          <div className="card-content">
            <p>
              <strong>Drivesoft</strong><br />
              SAS au capital de 1000 euros<br />
              Immatriculée au RCS de Pontoise sous le numéro 93982079100019<br />
              Siège social : 3 RUE MARLENE DIETRICH, 95220 HERBLAY-SUR-SEINE<br />
              Numéro de TVA intracommunautaire : FR51939820791<br />
              Représentée par BRX Software & Invest<br />
              Contact : <a href="tel:0652807736">06 52 80 77 36</a> – <a href="mailto:contact@drivesoft.fr">contact@drivesoft.fr</a>
            </p>
          </div>
        </motion.div>

        <motion.div className="section" variants={itemVariant}>
          <h2>2. Directeur de la Publication</h2>
          <div className="card-content">
            <p>
              Breux Florent, en sa qualité de Directeur.
            </p>
          </div>
        </motion.div>

        <motion.div className="section" variants={itemVariant}>
          <h2>3. Hébergeur du Site</h2>
          <div className="card-content">
            <p>
              Amazon Web Services
            </p>
          </div>
        </motion.div>

        <motion.div className="section" variants={itemVariant}>
          <h2>4. Propriété intellectuelle</h2>
          <div className="card-content">
            <p>
              Le contenu du site (textes, images, logos, etc.) est protégé par les droits d'auteur et les marques déposées. Toute reproduction, représentation ou diffusion, en tout ou partie, est interdite sans autorisation préalable écrite de Drivesoft.
            </p>
          </div>
        </motion.div>

        <motion.div className="section" variants={itemVariant}>
          <h2>5. Cookies</h2>
          <div className="card-content">
            <p>
              Le site utilise des cookies techniques et analytiques. Les cookies analytiques sont soumis à votre consentement via le bandeau dédié. Vous pouvez retirer votre consentement à tout moment.
            </p>
          </div>
        </motion.div>

        <motion.div className="section" variants={itemVariant}>
          <h2>6. Liens hypertextes</h2>
          <div className="card-content">
            <p>
              Drivesoft n'est pas responsable du contenu des sites tiers vers lesquels des liens hypertextes sont établis. Ces liens sont fournis à titre informatif et ne constituent pas une approbation des sites liés.
            </p>
          </div>
        </motion.div>

        <motion.div className="section" variants={itemVariant}>
          <h2>7. Loi applicable</h2>
          <div className="card-content">
            <p>
              Le site est soumis à la loi française, notamment au RGPD et à la loi Informatique et Libertés. En cas de litige, les tribunaux français seront compétents.
            </p>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
}

export default LegalMentions;
